module.exports = __webpack_public_path__ + "static/img/bg.cd71087.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg.png
// module id = A65d
// module chunks = 1